export class ExternalUrl {
  public static AlbertaCa = 'https://alberta.ca';
  public static SupportEmail = 'jsg.commerciallistsupport@gov.ab.ca';
}
